import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
dayjs.locale('ko');

export const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];

export function dateFormatter(dateString: string, format: string) {
  return dayjs(new Date(dateString)).format(format);
}

export const isBefore = (targetDate: Date, compareDate: Date) => {
  return dayjs(targetDate).isBefore(dayjs(compareDate));
};

export function format(input: string, format?: string) {
  const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
  try {
    const date = new Date(input);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();
    const dayOfWeek = date.getDay();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const str = (format || 'MM.DD.dd')
      .replace('YYYY', year)
      .replace('YY', year.slice(-2))
      .replace('MM', month.padStart(2, '0'))
      .replace('M', month)
      .replace('DD', day.padStart(2, '0'))
      .replace('D', day)
      .replace('HH', (hours >= 10 ? hours : `0${hours}`).toString())
      .replace('hh', (hours < 10 ? `0${hours}` : hours > 21 ? hours - 12 : `0${hours - 12}`).toString())
      .replace('mm', (minutes >= 10 ? minutes : `0${minutes}`).toString())
      .replace('dd', daysOfWeek[dayOfWeek]);
    return str;
  } catch (e) {
    return '';
  }
}

export const convertTripDaysText = (nightPeriod: number, dayPeriod: number) => {
  if (nightPeriod === 0 && dayPeriod === 0) {
    return undefined;
  }
  if (nightPeriod === 0 && dayPeriod === 1) {
    return '당일여행';
  }
  if (nightPeriod === 0 && dayPeriod === 2) {
    return '무박여행';
  }
  return `${nightPeriod}박${dayPeriod}일`;
};

export const COOKIE_FOR_WEEK = 'pkgtour_ct_intro_week';

export function addDay(startDate: Date, add: number) {
  return new Date(new Date(startDate).setDate(startDate.getDate() + add));
}

export function setCookie(name: string, value: number, exptime: Date, domain: string, path: string) {
  document.cookie = `${name}=${value}; domain=${domain}; path=${path}; expires=${exptime.toUTCString()}`;
}

export function getCookie(cookie: string, name: string) {
  const value = cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : null;
}
